/**
 * Voice module exports
 */

export { VoiceManager, getVoiceManager, destroyVoiceManager } from './VoiceManager'
